/// <reference types="vite/types/importMeta" />
import i18next from "i18next";
import enFallbackContent from '../assets/locales/en.json';

const bundledResources = {
  en: {
    translation: enFallbackContent
  }
};

export const i18nextInitialized = i18next.init({
  lng: "en",
  resources: bundledResources,
  partialBundledLanguages: true,
  fallbackLng: "en"
});
